module.exports = __webpack_public_path__ + "img/icon4.ff9b3ee.webp";